import toast from "react-hot-toast";
import { db } from "../config/firebaseConfig";
import { UserAuth } from "../context/authContext";
import DashboardLayout from "./layout/DashboardLayout";
import MainComponent from "./MainComponent";

const Dashboard = () => {
  const { userData, user, logout } = UserAuth();
  const copyToClipboard = (e, data) => {
    e.preventDefault(); // Prevent the default action associated with the event

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Copied Successfully");
      },
      (err) => {
        toast.error("Failed to copy");
      },
    );
  };
  const createWallet = async () => {
    if (userData && userData.isWalletCreated) {
      toast.error("Wallet already created");
      return;
    }
    // update user doc in firebase
    await db.collection("users").doc(user.email).update({
      isWalletCreated: true,
    });

    toast.success("Wallet Created Successfully");
    window.location.reload();
  };
  return (
    <DashboardLayout>
      <MainComponent
        copyToClipboard={copyToClipboard}
        createWallet={createWallet}
        userData={userData}
        user={user}
        logout={logout}
      />
    </DashboardLayout>
  );
};

export default Dashboard;
